"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminMenu = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("utils/components");
const domain_1 = require("utils/domain");
const project_1 = require("utils/project");
const react_router_dom_1 = require("react-router-dom");
const auth_1 = require("common/auth");
const routes = __importStar(require("../modules"));
const logo_icon_gray_svg_1 = __importDefault(require("assets/logo-icon-gray.svg"));
const index_1 = require("../index");
const AdminMenu = () => {
    const { pathname } = (0, react_router_dom_1.useLocation)();
    const { role } = (0, auth_1.useUserPageAuthorization)();
    const isMaster = role === "master";
    return (react_1.default.createElement(react_1.default.Fragment, null,
        domain_1.stagingAlertName && (react_1.default.createElement("div", { style: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                color: "#fff",
                background: project_1.isProductionEnv ? "#f00c" : "#fff9",
                padding: "0 10px",
                zIndex: 1000,
            } }, domain_1.stagingAlertName)),
        react_1.default.createElement("div", { className: "aside-tools", style: {
                justifyContent: "center",
            } },
            react_1.default.createElement("div", { className: "aside-tools-label" },
                react_1.default.createElement("img", { style: {
                        height: "48px",
                        textAlign: "center",
                    }, src: logo_icon_gray_svg_1.default }))),
        react_1.default.createElement("div", { className: "menu is-menu-main" },
            react_1.default.createElement("ul", { className: "menu-list" },
                react_1.default.createElement("li", null,
                    react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_PROJECTS") },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-account-supervisor" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u30D7\u30ED\u30B8\u30A7\u30AF\u30C8\u4E00\u89A7"))),
                react_1.default.createElement("li", null,
                    react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("UPDATE_PERSONAL_SETTING") },
                        react_1.default.createElement("span", { className: "icon" },
                            react_1.default.createElement("i", { className: "mdi mdi-tune" })),
                        react_1.default.createElement("span", { className: "menu-item-label" }, "\u500B\u4EBA\u8A2D\u5B9A"))),
                isMaster && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("li", { style: {
                            color: "#eee",
                            marginTop: 15,
                            marginBottom: 5,
                            marginLeft: 5,
                        } }, "\u30B7\u30B9\u30C6\u30E0\u7BA1\u7406\u8005\u30E1\u30CB\u30E5\u30FC"),
                    react_1.default.createElement("li", null,
                        react_1.default.createElement(components_1.Link, { to: (0, index_1.resolveRoute)("LIST_USER_AUTH"), className: routes.UPDATE_USER_AUTH.match(pathname) ||
                                routes.CREATE_USER_AUTH.match(pathname)
                                ? "navbar-item is-edit"
                                : undefined },
                            react_1.default.createElement("span", { className: "icon" },
                                react_1.default.createElement("i", { className: "mdi mdi-account-supervisor" })),
                            react_1.default.createElement("span", { className: "menu-item-label" }, "\u30B7\u30B9\u30C6\u30E0\u30E6\u30FC\u30B6\u4E00\u89A7")))))))));
};
exports.AdminMenu = AdminMenu;
